// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2yBfo","subheader":"ReorderModal_subheader__1k0Pl","listWrap":"ReorderModal_listWrap__2mFBy"};